const Colors = {
  lightGray: "#c4c4c4",
  title: "#182429",
  description: "#64737f",
};

export default Colors;
